import { jsx as _jsx } from "react/jsx-runtime";
import { Background, Foreground } from '@front/sharedcomponents/Styles';
import { Resources } from '@shared/localizations/Resources';
import { ColumnAlignment } from '@shared/utils/Table/TableColumn.interface';
import { Typography } from '../../Typography/Typography';
import { TypographyLevel } from '../../Typography/TypographyLevel';
import { ColumnAlignmentStyles } from '../Table.interface';
export const TableHeaderDragCell = ({ column, rect, isActive = false }) => {
    const classNames = [
        'table-head-cell',
        Background.Secondary,
        Foreground.Hint,
        ColumnAlignmentStyles[ColumnAlignment.Center],
        'draggable',
        isActive ? 'active' : ''
    ];
    const className = classNames.join(' ');
    return (_jsx("th", { className: className, scope: "col", "data-testid": `${column.id}-draggable`, tabIndex: -1, "aria-hidden": true, style: {
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height
        }, children: _jsx(Typography, { level: TypographyLevel.BodySm, noWrap: true, children: Resources.getResource(column.localizationKey) }) }));
};
